import { LOCALES } from '../locales';

export default {
	[LOCALES.FRENCH]: {
		'hello': 'Bonjour, {name}!',
		'TÜM TERMİNALLER':'TOUS LES TERMINAUX',
        'BÖLÜM BAZINDA': 'BASÉ SUR LE DÉPARTEMENT',
        'FİLTRE BAZINDA': 'SUR BASE DE FILTRE',
		'Bildiren': 'Informe',
		'Renk': 'Couleur',
		'Sicil': 'Registre',
		'Parça': 'Pièce',
		'Hata': 'Erreur',
		'Saat': 'Heure',
		'Hata Türü': "Type d'Erreur",
		'Hata Sor': "Responsable d'Erreur",
		'Alt Sorumlu': 'Responsable Subalterne',
		'Kaydet': 'Enregistrer',
		'İşlem': 'Opération',
		'MONTAJ NO': 'N° de Montage',
		'BODY NO': 'N° de Carrosserie',
		'ARA': 'Rechercher',
		'Teknik Destek': 'Support Technique',
		'ARAÇ LİSTESİ': 'Liste de Véhicules',
		'MANUEL HATA': 'Erreur Manuelle',
		'ÇOKLU HATA': 'Erreurs Multiples',
		'HATA LİSTESİ': "Liste d'Erreurs",
		'HATA KOPYA': "Copier l'Erreur",
		'ÇIKIŞ': 'Sortie',
		'Toplam satır': 'Nombre total de lignes',
		'HATA GİRİŞ EKRANI': "Écran d'Entrée d'Erreur",
		'HIZLI KAYDET': 'Enregistrement Rapide',
		'KAYDET VE GEÇ': 'Enregistrer et Continuer',
		'HATA KAYIT': "Enregistrement d'Erreur",
		'TERMİNAL İLK RESMİ': 'Première Image du Terminal',
		'SIK GELEN HATA': 'Erreur Fréquente',
		'MANİFEST': 'Manifeste',
		'ÇIKIŞ': 'Sortie',
		'MODEL İLK RESMİ': 'Première Image du Modèle',
		'GERİ': 'Retour',
		'HATA LİSTESİ': "Liste d'Erreurs",
		'TEMİZLE': 'Effacer',
		'BÜYÜK FONT': 'Grande Police',
		'Harigami': 'Harigami',
		'Tarih': 'Date',
		'Terminal Listesi': 'Liste des Terminaux',
		'Sicil No': 'N° de Registre',
		'Şifre': 'Mot de Passe',
		'Giriş Yap': 'Se Connecter',
		'Kapat': 'Fermer',
		'Montaj No': 'N° de Montage',
		'Vardiya': 'Shift',
		'Girdiğiniz bilgiler hatalıdır!': 'Les informations que vous avez entrées sont incorrectes!',
		'Giriş yapılıyor...': 'Connexion en cours...',
		'Açıklama': 'Description',
		'Yapılan İşlem': 'Opération Effectuée',
		'Çıkış Departmanı': 'Département de Sortie',
		'Hata Sınıfı': "Catégorie d'Erreur",
		'Sık Gelen Hata': 'Erreur Fréquente',
		'Hata Sorumlusu': "Responsable d'Erreur",
		'Kaydedildi': 'Enregistré',
		'Örnek açıklama': 'Exemple de Description',
		'İptal': 'Annuler',
		'RENK': 'COULEUR',
		'HATA GİRİŞİ': "ENTRÉE D'ERREUR",
	}
}